import { Injectable } from '@angular/core';
import * as models from '../models';
import * as viewmodels from '../viewmodels';
import { TemplatedTasksService } from './templatedTask.service';
import { TemplateService } from './template.service';
import { HelperService } from './helper.service';

@Injectable()
export class TaskTypesService {
  constructor(
    private templatedTasksService: TemplatedTasksService,
    private templateService: TemplateService,
    private helperService: HelperService
  ) { }

  async loadTaskTypes(): Promise<viewmodels.MultiSelect[]> {
    const templatedTaskItems: viewmodels.MultiSelect[] = [];
    const allSteps = await this.primeTemplateSteps();
    await this.getTaskLibrary(templatedTaskItems, allSteps);
    await this.getTasksFromTemplates(templatedTaskItems, allSteps);
    return templatedTaskItems;
  }

  private async primeTemplateSteps(): Promise<models.Step[]> {
    const templates = await this.templateService.getAll();
    // Flatten all steps from all templates and phases
    return templates.flatMap(template => 
      template.phases.flatMap(phase => phase.steps)
    );
  }

  private async getTaskLibrary(templatedTaskItems: viewmodels.MultiSelect[], allSteps: models.Step[]): Promise<void> {
    let templatedTasks = await this.templatedTasksService.getAll();
    templatedTasks = templatedTasks.filter(task => task.dataCollectionDefinitions?.length > 0);
    const sortedTasks = this.helperService.sortArrayByStringField(templatedTasks, 'name');
    
    templatedTaskItems.push(...sortedTasks.map(task => ({
      id: task.id,
      displayValue: task.name,
      selected: false,
      dataCollectionDefinitions: task.dataCollectionDefinitions,
      templatedTaskId: task.id,
      stepId: null,
      subStepIds: allSteps.filter(i => i.templatedTaskId == task.id).map(i => i.uid)
    })));
  }

  private async getTasksFromTemplates(templatedTaskItems: viewmodels.MultiSelect[], allSteps: models.Step[]): Promise<void> {
    const tasks: models.Step[] = [];
    const templatedTasks = await this.templatedTasksService.getAll();

    // Process each step
    let filteredSteps = allSteps.filter(step => step.dataCollectionDefinitions?.length > 0);
    filteredSteps.forEach(step => {
      //only include steps that are NOT in the task library
      const isInTaskLibrary = templatedTasks.some(task => task.id === step.templatedTaskId);
      
      if (!isInTaskLibrary) {
        tasks.push(step);
      }
    });

    const sortedTasks = this.helperService.sortArrayByStringField(tasks, 'description');
    templatedTaskItems.push(...sortedTasks.map(task => ({
      id: task.uid,
      displayValue: task.description,
      selected: false,
      dataCollectionDefinitions: task.dataCollectionDefinitions,
      templatedTaskId: task.templatedTaskId,
      stepId: task.uid
    })));
  }
} 